import React, {Component} from 'react'
import OrderStatusEditForm from "./form/edit.component.jsx"
import SideBar from '../common/layout/sidebar.component.jsx'

class OrderStatusNew extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')
    }


    render() {
        return (
            <div>
                <OrderStatusEditForm type={this.props.match.params.type} rank={this.props.match.params.rank} />
            </div>
        );
    }
}

export default OrderStatusNew


// WEBPACK FOOTER //
// ./src/order-status/new.component.jsx